import { ReactElement, ReactNode, useState } from "react";

import "./sidebar.styles.scss";
import searchImage from "../../assets/sidebar-search-icon.svg";
import SearchInput from "../../components/search-input/search-input";
import TabsComponent from "../../components/tabs-component/tabs-component";
import MenuComponent from "../../components/menu/menu.component";
import { useDispatch } from "react-redux";
import { COLLAPSE_SIDEBAR } from "../../store/actions";
import FavouriteItemsComponent from "../../components/favourite-menu/favourite-menu.component";
import clsx from "clsx";

const SideBar: React.FC = (): ReactElement => {
  const dispatch = useDispatch();
  const [collapsedSidebar, setCollapsedSidebar] = useState(false);

  const toggleCollapsed = () => {
    dispatch({ type: COLLAPSE_SIDEBAR });
    setCollapsedSidebar(!collapsedSidebar);
  };

  const standardItems: () => ReactNode = (): ReactNode => {
    return <MenuComponent />;
  };

  const favouriteItems: () => ReactNode = (): ReactNode => {
    return <FavouriteItemsComponent />;
  };

  const items: any = [
    {
      key: "1",
      label: `Standard`,
      children: standardItems(),
    },
    {
      key: "2",
      label: `Favorite`,
      children: favouriteItems(),
    },
  ];

  return (
    <div className={clsx("sidebar-container flex flex-col", collapsedSidebar ? 'collasped' : '')}>
      {!collapsedSidebar && (
        <SearchInput
          placeholder="Menu search"
          className="sidebar-search"
          prefix={<img src={searchImage} alt="search-icon" />}
        />
      )}
      {!collapsedSidebar && <TabsComponent items={items} />}
      {collapsedSidebar && <MenuComponent />}
      <div className="collapse-icon flex">
        <img
          src={"/images/collapse-sidebar.svg"}
          alt="kamco sidebar collapse"
          onClick={toggleCollapsed}
        />
      </div>
    </div>
  );
};

export default SideBar;
